module.exports = __webpack_public_path__ + "img/campaigns.6338ca14.svg";